import { render, staticRenderFns } from "./CRMToggleCard.vue?vue&type=template&id=3f789353&scoped=true&"
import script from "./CRMToggleCard.vue?vue&type=script&lang=ts&"
export * from "./CRMToggleCard.vue?vue&type=script&lang=ts&"
import style0 from "./CRMToggleCard.vue?vue&type=style&index=0&id=3f789353&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f789353",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBadge,VCard,VCardTitle})
